module.exports = __webpack_public_path__ + "static/media/Fig3.70598575.jpg";